module.exports = "/images/ny-life2-3.jpg";